export interface DateRange {
  startDate?: Date;
  endDate?: Date;
}

export type Marker = symbol;

export const MARKERS: { [key: string]: Marker } = {
  FIRST_MONTH: Symbol('firstMonth'),
  SECOND_MONTH: Symbol('secondMonth')
};

export type Setter<T> = React.Dispatch<React.SetStateAction<T>> | ((value: T) => void);

export enum NavigationAction {
  Previous = -1,
  Next = 1
}

export type DefinedRange = {
  startDate: Date;
  endDate: Date;
  relativeStartTime?: Date;
  relativeEndTime?: Date;
  label: string;
};
